import { render, staticRenderFns } from "./NewFinalMemberAreaQuizz.vue?vue&type=template&id=6120e810&scoped=true&"
import script from "./NewFinalMemberAreaQuizz.vue?vue&type=script&lang=js&"
export * from "./NewFinalMemberAreaQuizz.vue?vue&type=script&lang=js&"
import style0 from "./NewFinalMemberAreaQuizz.vue?vue&type=style&index=0&id=6120e810&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6120e810",
  null
  
)

export default component.exports